export const environment = {
  production: false,
  local: false,                 // Used to determine if running on localhost when isDevMode() is true
  hubRequiresAuth: true,        // Enables route guard for hub when true
  apiBaseUrl: 'https://devapi.qwikcut.com/api',
  socketUrl: 'https://devapi.qwikcut.com',
};

/*
Use this profile to run locally and point at local api 
ng s --configuration development
 */
